import * as r from "react";
import { j as m } from "./utils-BdNIfrGQ.js";
import { u as S } from "./index-CCKe-Mpx.js";
import * as y from "react-dom";
import { c as E } from "./index-DLcqcWxM.js";
function W(e, t) {
  const n = r.createContext(t), s = (i) => {
    const { children: u, ...c } = i, l = r.useMemo(() => c, Object.values(c));
    return /* @__PURE__ */ m.jsx(n.Provider, { value: l, children: u });
  };
  s.displayName = e + "Provider";
  function o(i) {
    const u = r.useContext(n);
    if (u) return u;
    if (t !== void 0) return t;
    throw new Error(`\`${i}\` must be used within \`${e}\``);
  }
  return [s, o];
}
function A(e, t = []) {
  let n = [];
  function s(i, u) {
    const c = r.createContext(u), l = n.length;
    n = [...n, u];
    const f = (a) => {
      const { scope: v, children: C, ...p } = a, h = v?.[e]?.[l] || c, x = r.useMemo(() => p, Object.values(p));
      return /* @__PURE__ */ m.jsx(h.Provider, { value: x, children: C });
    };
    f.displayName = i + "Provider";
    function d(a, v) {
      const C = v?.[e]?.[l] || c, p = r.useContext(C);
      if (p) return p;
      if (u !== void 0) return u;
      throw new Error(`\`${a}\` must be used within \`${i}\``);
    }
    return [f, d];
  }
  const o = () => {
    const i = n.map((u) => r.createContext(u));
    return function(c) {
      const l = c?.[e] || i;
      return r.useMemo(
        () => ({ [`__scope${e}`]: { ...c, [e]: l } }),
        [c, l]
      );
    };
  };
  return o.scopeName = e, [s, P(o, ...t)];
}
function P(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const s = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const u = s.reduce((c, { useScope: l, scopeName: f }) => {
        const a = l(i)[`__scope${f}`];
        return { ...c, ...a };
      }, {});
      return r.useMemo(() => ({ [`__scope${t.scopeName}`]: u }), [u]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
// @__NO_SIDE_EFFECTS__
function R(e) {
  const t = /* @__PURE__ */ b(e), n = r.forwardRef((s, o) => {
    const { children: i, ...u } = s, c = r.Children.toArray(i), l = c.find(w);
    if (l) {
      const f = l.props.children, d = c.map((a) => a === l ? r.Children.count(f) > 1 ? r.Children.only(null) : r.isValidElement(f) ? f.props.children : null : a);
      return /* @__PURE__ */ m.jsx(t, { ...u, ref: o, children: r.isValidElement(f) ? r.cloneElement(f, void 0, d) : null });
    }
    return /* @__PURE__ */ m.jsx(t, { ...u, ref: o, children: i });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function b(e) {
  const t = r.forwardRef((n, s) => {
    const { children: o, ...i } = n;
    if (r.isValidElement(o)) {
      const u = j(o), c = $(i, o.props);
      return o.type !== r.Fragment && (c.ref = s ? E(s, u) : u), r.cloneElement(o, c);
    }
    return r.Children.count(o) > 1 ? r.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var g = /* @__PURE__ */ Symbol("radix.slottable");
function w(e) {
  return r.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === g;
}
function $(e, t) {
  const n = { ...t };
  for (const s in t) {
    const o = e[s], i = t[s];
    /^on[A-Z]/.test(s) ? o && i ? n[s] = (...c) => {
      const l = i(...c);
      return o(...c), l;
    } : o && (n[s] = o) : s === "style" ? n[s] = { ...o, ...i } : s === "className" && (n[s] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function j(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function H(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e?.(o), n === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
var _ = r[" useInsertionEffect ".trim().toString()] || S;
function B({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: s
}) {
  const [o, i, u] = O({
    defaultProp: t,
    onChange: n
  }), c = e !== void 0, l = c ? e : o;
  {
    const d = r.useRef(e !== void 0);
    r.useEffect(() => {
      const a = d.current;
      a !== c && console.warn(
        `${s} is changing from ${a ? "controlled" : "uncontrolled"} to ${c ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), d.current = c;
    }, [c, s]);
  }
  const f = r.useCallback(
    (d) => {
      if (c) {
        const a = N(d) ? d(e) : d;
        a !== e && u.current?.(a);
      } else
        i(d);
    },
    [c, e, i, u]
  );
  return [l, f];
}
function O({
  defaultProp: e,
  onChange: t
}) {
  const [n, s] = r.useState(e), o = r.useRef(n), i = r.useRef(t);
  return _(() => {
    i.current = t;
  }, [t]), r.useEffect(() => {
    o.current !== n && (i.current?.(n), o.current = n);
  }, [n, o]), [n, s, i];
}
function N(e) {
  return typeof e == "function";
}
var D = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], F = D.reduce((e, t) => {
  const n = /* @__PURE__ */ R(`Primitive.${t}`), s = r.forwardRef((o, i) => {
    const { asChild: u, ...c } = o, l = u ? n : t;
    return typeof window < "u" && (window[/* @__PURE__ */ Symbol.for("radix-ui")] = !0), /* @__PURE__ */ m.jsx(l, { ...c, ref: i });
  });
  return s.displayName = `Primitive.${t}`, { ...e, [t]: s };
}, {});
function L(e, t) {
  e && y.flushSync(() => e.dispatchEvent(t));
}
export {
  F as P,
  A as a,
  R as b,
  H as c,
  W as d,
  L as e,
  B as u
};
